<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'screen-form-item',
})
</script>
<template>
  <div
    class="form-item-col __lf-form-item"
    :style="{
      width: `${spanNum}%`
    }"
  >
    <el-form-item v-bind="props">
      <template v-slot:label="label">
        <span class="form-label">
          <slot
            v-if="slots.label"
            name="label"
          ></slot>
          <template v-else>{{ label.label }}</template>
        </span>
      </template>

      <slot></slot>
    </el-form-item>
  </div>
</template>

<script lang="ts" setup name="screen-form-item">
  import { inject, useSlots } from 'vue';
  import type { FormItemProps } from 'element-plus';

  type LFFormItemProps = FormItemProps & {
    [key: string]: any
  }

  const props = defineProps<LFFormItemProps>();

  const slots = useSlots();

  const spanNum = inject('$_computed_span');
</script>

<style lang="scss" scoped>
  .form-item-col {
    box-sizing: border-box;
    padding-left: 12px;

    :deep(.#{$namespace}-form-item) {
      margin-bottom: 12px;

      .#{$namespace}-form-item__label {
        display: flex;
        align-items: center;
      }
    }

    .form-label {
      line-height: 17px;
      text-align: right;
      word-break: break-all;
    }
  }
</style>
